import type { ReactNode } from 'react';
import { Box, Stack, Typography } from './mui-system';

export function PageHeader({
  title,
  description,
  action,
}: {
  title: string;
  description: string;
  action?: ReactNode;
}) {
  return (
    <Stack direction="row" flexWrap="wrap" alignItems="flex-start" gap={3} mb={3}>
      <Box sx={{ flex: '1 1 360px', minWidth: 0, maxWidth: 760 }}>
        <Typography variant="h2" component="h1" mb={0.7}>
          {title}
        </Typography>
        <Typography color="text.secondary" fontSize={{ xs: 14, md: 16 }}>
          {description}
        </Typography>
      </Box>
      {action && (
        <Stack
          role="group"
          aria-label="Действия раздела"
          direction="row"
          flexWrap="wrap"
          alignItems="center"
          justifyContent={{ xs: 'flex-start', sm: 'flex-end' }}
          gap={1}
          sx={{
            ml: { sm: 'auto' },
            maxWidth: '100%',
            '&:empty': { display: 'none' },
            '& .MuiButton-root': { height: 38, whiteSpace: 'nowrap' },
          }}
        >
          {action}
        </Stack>
      )}
    </Stack>
  );
}
